import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

import { FiltroRotacionCXC } from "./FiltroRotacionCXC";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useBoxProyecciones } from "../ProyeccionesVentas/useBoxProyecciones";

export const DetalleCXCMainScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
    const [inventario, setInventario] = useState();
    const [editarGuia, setEditarGuia] = useState(false);
    const [totales, setTotales] = useState();
    const [rotacion, setRotacion] = useState();
    const [titulo, setTitulo] = useState("DETALLE CUENTAS POR COBRAR");
    const [sucursalesSeleccionadasArray, setSucursalesSeleccionadasArray] = useState(
        location.state?.sucursalesSeleccionadasArray || []
    );
    const [etiquetaSucursal, setEtiquetaSucursal] = useState(null);
    const [departamentosSeleccionadosArray, setDepartamentosSeleccionadosArray] = useState(
        location.state?.departamento || []
    );


    const sucursales = location.state?.sucursales;
    const sucursalesSeleccionadas = location.state?.sucursalesSeleccionadas || 0;
    const ejercicioSelect = location.state?.ejercicioSelect || 0;
    const periodoSelect = location.state?.periodoSelect || 0;
    const tipoReporte = location.state?.tipoReporte || 0;
    const optima = location.state?.optima || false;

    const filtroGuardado = (() => {
        const raw = sessionStorage.getItem("rotacion_cxc_filtro");
        return raw ? JSON.parse(raw)?.filtro : null;
    })();

    // console.log(sucursalesSeleccionadas)

    const meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        const today = new Date();
        let currentMonth = today.getMonth() + 1;
        let currentYear = today.getFullYear();

        const ejercicio = ejercicioSelect === 0 ? currentYear : ejercicioSelect
        const mes = periodoSelect === 0 ? currentMonth : periodoSelect

        const sucursales = sucursalesSeleccionadas?.length
            ? sucursalesSeleccionadas
            : ["0"];

        onIniciar(ejercicio, mes, sucursales, tipoReporte, departamentosSeleccionadosArray);

    }, []);

    const onIniciar = (
        ejercicio,
        periodo,
        sucursal,
        tipoReporte,
        departamentoseleccionado
    ) => {

        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var departamento = GetKey(departamentosSeleccionadosArray, ["iddepartamento"]);

        // console.log(ejercicio, periodo)

        updateBoxState((prev) => ({
            ...prev,
            ejercicioinicio: ejercicio,
            periodofin: periodo,
            pv: prev.pv ?? {} // opcional seguridad
        }));

        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (departamento === undefined || departamento === null || departamento === "") {
            departamento = "0";
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `RotacionCXC/detalleCXC?ejercicio=${ejercicio}&periodo=${periodo}&adr=${adr}&sucursales=${sucursal}&departamentos=${departamento}&tipoReporte=${tipoReporte}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });

                    const filasBody = result.filter(
                        item => item.departamento !== "TOTALES" && item.departamento !== "ROTACION TOTAL"
                    );

                    // const totales = result.rotacion.find(item => item.departamento === "TOTALES");
                    // const rotacionTotal = result.rotacion.find(item => item.departamento === "ROTACION TOTAL");

                    setInventario(filasBody);
                    // setTotales(totales);
                    // setRotacion(rotacionTotal);
                    setEditarGuia(result.editor_guia)

                    const mesFinalIndex = periodo - 1;      // periodo: 1–12
                    const mesFinal = meses[mesFinalIndex];
                    const anioFinal = ejercicio;

                    const tituloP = `DETALLE CUENTAS POR COBRAR ${mesFinal} ${anioFinal}`;

                    setTitulo(tituloP)

                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    // console.log(boxstate)

    const onExecute = (
    ) => {

        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var departamento = GetKey(boxstate.pv.departamento, ["iddepartamento"]);


        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (departamento === undefined || departamento === null || departamento === "") {
            departamento = "0";
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `RotacionCXC/detalleCXC?ejercicio=${boxstate.ejercicioinicio}&periodo=${boxstate.periodofin}&adr=${adr}&sucursales=${sucursales}&departamentos=${departamento}&tipoReporte=${tipoReporte}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    // console.log(result)

                    const filasBody = result.filter(
                        item => item.departamento !== "TOTALES" && item.departamento !== "ROTACION TOTAL"
                    );

                    const sucursalActiva = boxstate.pv.sucursal || [];
                    const adrActiva = boxstate.pv.adr || [];
                    setSucursalesSeleccionadasArray(sucursalActiva);
                    setDepartamentosSeleccionadosArray(boxstate.pv.detartamento || []);

                    if (sucursalActiva.length > 0) {
                        setEtiquetaSucursal(sucursalActiva.map(s => capitalizeWords(s.sucursal)).join(', '));
                    } else if (adrActiva.length > 0) {
                        setEtiquetaSucursal(adrActiva.map(a => capitalizeWords(a.adr)).join(', '));
                    } else {
                        setEtiquetaSucursal("Todas");
                    }


                    // const totales = result.rotacion.find(item => item.departamento === "TOTALES");
                    // const rotacionTotal = result.rotacion.find(item => item.departamento === "ROTACION TOTAL");

                    setInventario(filasBody);
                    // setTotales(totales);
                    // setRotacion(rotacionTotal);
                    setEditarGuia(result.editor_guia)

                    const mesFinalIndex = boxstate.periodofin - 1;      // periodo: 1–12
                    const mesFinal = meses[mesFinalIndex];
                    const anioFinal = boxstate.ejercicioinicio;


                    const tituloP = `DETALLE CUENTAS POR COBRAR ${mesFinal} ${anioFinal}`;

                    setTitulo(tituloP)

                    resolve(result); // 🔥 IMPORTANTE
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    // console.log(departamentosSeleccionadosArray)
    const onGeneraExcel = (
    ) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var departamento = GetKey(departamentosSeleccionadosArray?.length === 0 || departamentosSeleccionadosArray === null || departamentosSeleccionadosArray === null ? boxstate.pv.departamento : departamentosSeleccionadosArray, ["iddepartamento"]);

        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (departamento === undefined || departamento === null || departamento === "") {
            departamento = "0";
        }

        setLoader(prev => ({ ...prev, mostrar: true }));
        request
            .get(
                `RotacionCXC/ImprimirExcelDetalle?ejercicio=${boxstate.ejercicioinicio}&periodo=${boxstate.periodofin}&adr=${adr}&sucursales=${sucursales}&departamentos=${departamento}&tipoReporte=${tipoReporte}&titulo=${titulo}`
            )
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                // Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onRegresar = () => {
        if(!optima) {
        history.push("/Finanzas/RotacionCXC", {
            sucursales: sucursales,
            sucursalesSeleccionadas: sucursalesSeleccionadas,
            periodoSelect: periodoSelect,
            ejercicio: ejercicioSelect,
        });
    } else {
        history.push("/Finanzas/RotacionCXCOptima", {
            sucursales: sucursales,
            sucursalesSeleccionadas: sucursalesSeleccionadas,
            periodoSelect: periodoSelect,
            ejercicio: ejercicioSelect,
            optima: true
        });
    }

    };


    const capitalizeWords = (str) => {
        return str
            ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
    };

    return (
        <PlantillaScreen
            titulo={titulo}
            className={"detalle-cxc-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />

            <div className="detalle-cxc-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-recuperacion-responsable-actions-filtro">
                    <FiltroRotacionCXC
                        onBoxChange={setBoxState}
                        boxState={boxstate}
                        BoxClick={onExecute}
                        updateBoxState={updateBoxState}
                        titulo_filtro={"FILTRO ROTACION CXC"}
                        // titulo='Estado de Resultados Comparativo real vs proyeccion'
                        // subtitulo={SubTitulo()}
                        extrayear={3}
                        ejercicioPersistente={ejercicioSelect}
                        periodoPersistente={periodoSelect}
                        sucursales={sucursales}
                        filtroInicial={filtroGuardado}
                    />
                </div>


                <div className="buttons-cxc">

                    <button className="excel"
                        onClick={() => onGeneraExcel()}
                    >
                        {/* <AddCircleIcon /> */}
                        <i className=" icon-file-excel" /> Excel
                    </button>
                </div>
            </div>
            <div className="dash-filtro-usados-container">
                <div className="dash-filtro-usados-sucursal">
                    <div className="dash-filtro-usado-titulo">
                        Sucursal:
                    </div>
                    <div className="dash-filtro-usado-parametros">
                        {etiquetaSucursal
                            ?? (filtroGuardado
                                ? capitalizeWords(filtroGuardado.descripcion)
                                : "Todas")}
                    </div>

                </div>
            </div>
            <div className="dash-filtro-usados-container">
                <div className="dash-filtro-usados-sucursal">

                    <div className="dash-filtro-usado-titulo">
                        Departamentos:
                    </div>
                    <div className="dash-filtro-usado-parametros">
                        {departamentosSeleccionadosArray.length === 0
                            ? "Todos"
                            : departamentosSeleccionadosArray
                                .map(s => capitalizeWords(s.departamento))
                                .join(', ')
                        }
                    </div>

                </div>
            </div>

            {
                inventario && inventario.length > 0 && (
                    <div className="detalle-cxc-main-container">
                        <div className="rotacion-cxc-tabla-container scroll">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr>
                                        <th>
                                            Cliente
                                        </th>
                                        <th>
                                            <div>Sucursal</div>
                                        </th>
                                        <th>
                                            <div>Departamento</div>
                                        </th>
                                        <th>
                                            <div>Fecha Factura</div>
                                        </th>
                                        <th>
                                            <div>Importe</div>
                                        </th>
                                        {/* <th>
                                            <div>Iva</div>
                                        </th>
                                        <th>
                                            <div>Abonos</div>
                                        </th>
                                        <th>
                                            <div>Saldo</div>
                                        </th> */}
                                        <th>
                                            <div>Serie</div>
                                        </th>
                                        <th>
                                            <div>Folio</div>
                                        </th>
                                        {/* <th>
                                            <div>Documento Interno</div>
                                        </th> */}
                                        <th>
                                            <div>Documento Factura</div>
                                        </th>

                                        {/* <th>
                                            <div>Dias Vencidos</div>
                                        </th> */}
                                        <th>
                                            <div>Batch</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Usar map para renderizar las filas de la tabla */}
                                    {inventario.map((item, index) => (
                                        <tr>
                                            <td
                                                className="celda-cliente"

                                            >
                                                {capitalizePalabras(item.cliente)}
                                            </td>
                                            <td
                                                className="celda-vendedor"

                                            >
                                                {capitalizePalabras(item.sucursal)}
                                            </td>
                                            <td
                                                className="celda-vendedor"

                                            >
                                                {capitalizePalabras(item.departamento)}
                                            </td>
                                            <td className="ta-center">
                                                {(() => {
                                                    if (!item.fecha_factura) return "";

                                                    const fecha = new Date(item.fecha_factura);

                                                    if (isNaN(fecha.getTime())) return "";

                                                    const dd = String(fecha.getDate()).padStart(2, "0");
                                                    const mm = String(fecha.getMonth() + 1).padStart(2, "0");
                                                    const yyyy = fecha.getFullYear();

                                                    const formatted = `${dd}/${mm}/${yyyy}`;

                                                    return formatted === "01/01/1900" ? "" : formatted;
                                                })()}
                                            </td>

                                            <td
                                                className="ta-right"
                                            >
                                                {FormatMoney(item.importe, 0)}
                                            </td>
                                            {/* <td
                                                className="ta-right"
                                            >
                                                {FormatMoney(item.iva, 0)}
                                            </td>
                                            <td className="ta-right">{FormatMoney(item.abonos, 2)}</td>
                                            <td className="ta-right">{FormatMoney(item.saldo, 2)}</td> */}
                                            <td className="ta-center">{item.serie}</td>
                                            <td className="ta-center">{item.folio}</td>
                                            {/* <td className="ta-center">{item.documento_interno}</td> */}
                                            <td className="ta-center">{item.documento_factura}</td>
                                            {/* <td className="ta-center">{item.dias_vencido}</td> */}
                                            <td className="ta-center">{item.batch}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>

                                        <td className="celda-vendedor">{"TOTALES"}</td>
                                        <td className="ta-right"></td>
                                        <td className="ta-right"></td>
                                        {/* <td className="ta-right"> {FormatMoney(inventario.reduce((acumulador, item) => acumulador + item.iva, 0), 2)}</td>
                                        <td className="ta-right">{FormatMoney(inventario.reduce((acumulador, item) => acumulador + item.abonos, 0), 2)}</td>
                                        <td className="ta-right">{FormatMoney(inventario.reduce((acumulador, item) => acumulador + item.saldo, 0), 2)}</td> */}
                                        <td className="ta-center"></td>
                                        <td className="ta-right">{FormatMoney(inventario.reduce((acumulador, item) => acumulador + item.importe, 0), 2)}</td>
                                        <td className="ta-center"></td>
                                        <td className="ta-center"></td>
                                        <td className="ta-center"></td>
                                        <td className="ta-center"></td>
                                        <td className="ta-center"></td>
                                    </tr>

                                </tfoot>

                            </table>
                        </div>
                    </div >
                )
            }
        </PlantillaScreen >
    );
};
